import React, { useState } from "react";
import styles from "./AdminComplianceMGMT.module.css";
import Mixing from "./Mixing/Mixing";
import { ReactComponent as TabIcon } from "../../../../assets/images/tabIcon.svg";
import MakeUp from "./MakeUp/MakeUp";
import Proofing from "./Proofing/Proofing";
import Chilling from "./Chilling/Chilling";
import Oven from "./Oven/Oven";
import Packaging from "./Packaging/Packaging";
import Assembly from "./Assembly/Assembly";
import HeaderComponent from "../../../../components/HeaderComponent/HeaderComponent";
import TopTabComponent from "../../../../components/TopTabComponent/TopTabComponent";
import { ReactComponent as EditIcon } from "../../../../assets/images/editIcon.svg";
import { useNavigate } from "react-router-dom";

const AdminComplianceMGMT = () => {
  const navigate = useNavigate();
  const options = [
    { id: 1, name: "Mixing", Icon: <TabIcon width={16} height={16} /> },
    { id: 2, name: "Assembly", Icon: <TabIcon width={16} height={16} /> },
    { id: 3, name: "Proofing", Icon: <TabIcon width={16} height={16} /> },
    { id: 4, name: "Chilling", Icon: <TabIcon width={16} height={16} /> },
    { id: 5, name: "Oven", Icon: <TabIcon width={16} height={16} /> },
    { id: 6, name: "Packaging", Icon: <TabIcon width={16} height={16} /> },
    { id: 7, name: "Make Up", Icon: <TabIcon width={16} height={16} /> },
  ];
  const [focusedTab, setFocusedTab] = useState(options[0]);
  return (
    <div className={styles.mainCont}>
      <HeaderComponent
      childrenStyle={styles.headerButton}
      children={
         <EditIcon className={styles.topIcon}  onClick={()=> navigate('/AdminProductManagement/CreateComplianceManagement')}  />
      }
        showBackIcon={false}
        heading={"GMP Compliance Management"}
        headingStyle={styles.Heading}
      />
      <TopTabComponent
        options={options}
        focused={focusedTab}
        setFocused={setFocusedTab}
        TopTabListStyle={styles.TopTabListStyle1}
      />

      {focusedTab?.name === options[0]?.name && <Mixing />}
      {focusedTab?.name === options[1]?.name && <Assembly />}
      {focusedTab?.name === options[2]?.name && <Proofing />}
      {focusedTab?.name === options[3]?.name && <Chilling />}
      {focusedTab?.name === options[4]?.name && <Oven />}
      {focusedTab?.name === options[5]?.name && <Packaging />}
      {focusedTab?.name === options[6]?.name && <MakeUp />}
    </div>
  );
};

export default AdminComplianceMGMT;
